export const requiredHelpText = { text: 'This field is required' } as const;

export const invalidNumberHelpText = {
  text: 'Must be a valid number',
} as const;
